module.exports = __webpack_public_path__ + "static/a-family-of-titan-scholars-image-2-533x800-bd4cc85b76fe09c909ba62bef9852e10.jpg";